declare global {
  interface Window {
    ReactNativeWebView: {
      postMessage(msg: string): void;
    };
  }
}

export const sendMessageToApp = (message: Record<string, string>) => {
  window.ReactNativeWebView &&
    window.ReactNativeWebView.postMessage(JSON.stringify(message));
};

export function getSubdomain(url: string): string | null {
  try {
    const { hostname } = new URL(url);
    const parts = hostname.split('.');

    if (hostname.endsWith('localhost')) {
      if (parts.length >= 2) {
        return parts[0];
      }
      return null;
    }
    if (parts.length > 3) {
      const subdomains = parts.slice(0, parts.length - 3);
      return subdomains[0];
    }

    return null;
  } catch {
    return null;
  }
}

export function hasCustomSubdomain(url: string): boolean {
  const subdomain = getSubdomain(url);
  if (!subdomain) return false;

  return subdomain !== 'buyer';
}
